/**
 * External tasks v1 (260702) bod 2 — external-actor reassign hook.
 *
 * MKS-132: any external member of the project reassigns the task to an
 * internal user or an external member via the external board API (cookie
 * creds). On success invalidates the external board query so the task moves
 * to the new assignee's filtered view. Errors (403 non-member, off-project
 * target) surface to the calling component as an ExternalApiError → toast.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reassignExternalTask } from '../services/api/externalBoard';

export interface UseExternalReassignInput {
  taskId: number;
  target: { kind: 'user' | 'external_user'; id: number };
  projectId: number;
}

export function useExternalReassign() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ taskId, target }: UseExternalReassignInput) =>
      reassignExternalTask(taskId, target),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({
        queryKey: ['board', String(vars.projectId), 'external'],
      });
    },
  });
}
